import { Injectable } from '@angular/core';

/**
 *  Games Topics. Be aware of syncronize any change here with api-games (models/game.js).
 *  @type  {Array}
 */
const TOPICS = ['negotiation', 'time_management', 'team_management', 'customer_service', 'onboarding', 'gdpr'];

@Injectable()
export class TopicsService {
  getOptions() {
    return TOPICS.map((topic) => {
      return {
        // The key must exist in the lms-notifications translator. It will be used when sending mails
        // The value must be a string to be internationalized and will be used to display the topic in this platform
        key: `games.topics.${topic}`,
        value: `games.topics.${topic}`
      };
    });
  }
}
